/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Written by scripts/resolve-client-env.mjs immediately before every build.
 * The committed version of this file holds EMPTY strings on purpose: these
 * values are per-deploy-target and must never be a literal in source (a
 * literal here is exactly what let production inherit staging's Stripe mode
 * for eighteen days).
 *
 * Why a generated module instead of process.env: NEXT_PUBLIC_* inlining is not
 * deterministic in this repo's bundle — see the header of resolve-client-env.mjs.
 */
export const CLIENT_STRIPE_PUBLISHABLE_KEY = "pk_live_51Ks6aGARRLAT1NSnj8jpURCiUxrDQm5L4hxNgyyAwCRPZNmDev2oYEHz9GB4J7oJ0xyBNUScKrIZ9J8BhDkESZBa000f4DQcfR";
export const CLIENT_PLATFORM_ORIGIN = "https://app.pianofantasy.com";
